import { ApiRequestError } from "../types/api";

/** Best-effort human-readable message from any thrown value (API or otherwise). */
export function getErrorMessage(error: unknown): string {
  if (error instanceof ApiRequestError) {
    return error.fieldErrorText
      ? `${error.message} — ${error.fieldErrorText}`
      : error.message;
  }
  if (error instanceof Error) return error.message;
  return "Something went wrong. Please try again.";
}
